module.exports = __webpack_public_path__ + "static/media/Untitled-1.ed240154.png";